import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { ShiftSelect } from '../../Shared/ShiftSelect'
import AsyncPersonnelSelect from '../../Shared/AsyncPersonnelSelect'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <fieldset className="fieldset">
        <legend>اطلاعات پرسنل</legend>

        <div className="row">
          <div className="form-inline">

            <div className="col-md-2 col-sm-12">
              <label>شیفت</label>
              <ShiftSelect

                defaultValue={values.shift}
                name="shift"
                onChange={(val) => {
                  console.log(val);

                  setFieldValue('shift', val)
                }}

                className={getIn(touched, "shift") ? getIn(errors, "shift") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="shift" />
            </div>

            <div className="col-md-2 col-sm-12">
              <label>سرشیفت</label>
              <AsyncPersonnelSelect name="shiftManager"
                required
                closeMenuOnSelect
                defaultValue={values.shiftManager}
                onChange={(val) => {
                  setFieldValue('shiftManager', val);
                }}
              />
              <ErrorMessage component={ErrorPopUp} name="shiftManager" />
            </div>

            <div className="col-md-2 col-sm-12">
              <label>مسئول کلیک</label>
              <AsyncPersonnelSelect name="unitManager"
                required
                closeMenuOnSelect
                defaultValue={values.unitManager}
                onChange={(val) => {
                  console.log(val);

                  setFieldValue('unitManager', val);
                }}
              />
              <ErrorMessage component={ErrorPopUp} name="unitManager" />
            </div>

            <div className="col-md-2 col-sm-12">
              <label>کنترل کیفی</label>
              <AsyncPersonnelSelect name="qc"
                required
                closeMenuOnSelect
                defaultValue={values.qc}
                onChange={(val) => {
                  console.log(val);

                  setFieldValue('qc', val);
                }}
              />
              <ErrorMessage component={ErrorPopUp} name="qc" />
            </div>

            <div className="col-md-4 col-sm-12">
              <label>اپراتورهای کلیک</label>
              <AsyncPersonnelSelect name="techniciens"
                required
                isMulti
                closeMenuOnSelect={false}
                defaultValue={values.techniciens}
                onChange={(val) => {
                  setFieldValue('techniciens', val);
                }}
              />
              <ErrorMessage component={ErrorPopUp} name="techniciens" />
            </div>


          </div>
        </div>
      </fieldset>
    </div>
  </div>
);